// Конфигурация для Telegram Web App

export const TELEGRAM_CONFIG = {
  // Отключение логов Telegram Web App
  disableTelegramLogs: process.env.NODE_ENV === 'production' || process.env.REACT_APP_DISABLE_TELEGRAM_LOGS === 'true',
  
  // Цвета интерфейса
  headerColor: '#17212b',
  backgroundColor: '#17212b',
  
  // Настройки MainButton
  mainButtonColor: '#ec0e0e', // '#34a4eb',
  mainButtonInactiveColor: '#757575',
  
  // Настройки отладки
  enableDebugLogs: process.env.NODE_ENV === 'development' && process.env.REACT_APP_ENABLE_DEBUG_LOGS === 'true',
};

// Функция для проверки, нужно ли отключать логи
export const shouldDisableTelegramLogs = () => {
  return TELEGRAM_CONFIG.disableTelegramLogs;
};

// Функция для проверки, нужно ли включать отладочные логи
export const shouldEnableDebugLogs = () => {
  return TELEGRAM_CONFIG.enableDebugLogs;
};
